import { AppButton } from '@/ui/buttons';
import { SimpleLockIcon } from '@/utils/helpers/icons.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type AccessBlockedPanelProps = {
  variant: 'free-trial' | 'no-access';
  onBookMeeting?: () => void;
};

const Panel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px; /* No matching token - Figma: 32px */
  width: 100%;
  padding: var(--xlarge-padding) 0 80px; /* No matching token - Figma: 70px / 80px */
  background-color: var(--beige-main);
  border-radius: var(--medium-border-radius);
  text-align: center;
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--big-padding);
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 134px;
  height: 134px;

  svg {
    width: 78px;
    height: 100px;
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--medium-padding);
`;

const Title = styled.h2`
  margin: 0;
  max-width: var(--blank-state-title-width);
  font-size: var(--modal-heading-font-size);
  line-height: 1.5; /* No matching token - Figma: 37.5px */
  font-weight: var(--bold-font-weight);
`;

const Body = styled.p`
  margin: 0;
  max-width: var(--blank-state-body-width);
  font-size: var(--medium-font-size);
  font-weight: var(--regular-font-weight);
  line-height: var(--medium-line-height);
`;

export const AccessBlockedPanel: React.FC<AccessBlockedPanelProps> = ({
  variant,
  onBookMeeting,
}) => {
  const { t } = useTranslation();
  const isFreeTrial = variant === 'free-trial';

  return (
    <Panel>
      <Message>
        <IconWrapper>
          <SimpleLockIcon />
        </IconWrapper>

        <TextBlock>
          <Title>
            {isFreeTrial
              ? t('account.rolesAccess.blocked.freeTrial.title')
              : t('permissions.blocked.title')}
          </Title>
          <Body>
            {isFreeTrial
              ? t('account.rolesAccess.blocked.freeTrial.body')
              : t('permissions.blocked.body')}
          </Body>
        </TextBlock>
      </Message>

      {isFreeTrial && onBookMeeting && (
        <AppButton
          label={t('account.rolesAccess.blocked.freeTrial.cta')}
          onClick={onBookMeeting}
        />
      )}
    </Panel>
  );
};
